import React from "react";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import { getToolTip } from "../../../../utils/getToolTip";
import { useSelector } from "react-redux";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const NetUnitMtdStatsPrevious = () => {
  const statistics = useSelector((state) => state.membershipSales.statistics);
  const {
    units: { prevNetUnitsMTD, prevNetUnitsMTDLink }
  } = statistics;
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <SectionContainer
      title="Previous Net Units MTD"
      toolTip={`Previous ${getToolTip(statistics)}`}
      toolTipId="membershipPreviousNewUnitsMTDToolTip"
    >
      <NumberDisplay
        value={prevNetUnitsMTD}
        url={prevNetUnitsMTDLink}
        disableAnimation={isUserQa}
        toolTipContent={`Previous ${getToolTip(statistics)}`}
        toolTipId="membershipPreviousNewUnitsToolTipMTD"
      />
    </SectionContainer>
  );
};

export default NetUnitMtdStatsPrevious;
